import React, { FC, useContext, useEffect, useState } from 'react';
import { DataObjectBase, DataObjectType, ObjectProperty } from '../../model/data';
import { DataObjectComponentFactory } from './components';
import { DataComponentPropTypes } from './components/data-component-prop-types';
import Card from 'react-bootstrap/Card';
import { DataObjectCard } from './components/data-object-card';
import { AuthUserContext } from '@yakoffice/yakoffice-firebase';
import { useParams } from 'react-router-dom';
import { IsPropertyEditable } from './data-object-edit-controller';
import { Accordion } from 'react-bootstrap';
import styles from './data-object-component.module.sass';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

export const complexPropertyTypes = [DataObjectType.object, DataObjectType.array, DataObjectType.postable];

export const DataObjectComponent: FC<DataComponentPropTypes<ObjectProperty>> = ({
                                                                                    route,
                                                                                    dataObject,
                                                                                    playerIsLocked
                                                                                }) => {

    const authUser = useContext(AuthUserContext);
    const { projectId, gameEnvironmentId } = useParams() as {
        projectId: string,
        gameEnvironmentId: string,
        itemId: string
    };

    const simpleProperties = dataObject.value.filter(p => !complexPropertyTypes.includes(p.type));
    const complexProperties = dataObject.value.filter(p => complexPropertyTypes.includes(p.type));
    const [customRowWidth, setCustomRowWidth] = useState<number | undefined>();

    const handleResize = () => {
        const width = document.getElementById('dataObjectCard')?.clientWidth;
        width !== customRowWidth && setCustomRowWidth(document.getElementById('dataObjectCard')?.clientWidth);
    };

    useEffect(() => {

        const customRow = document.getElementById('dataObjectCard');

        if (customRow) {
            setCustomRowWidth(customRow.clientWidth);

            new ResizeObserver(() => {
                handleResize();
            }).observe(customRow);
        }

        window.addEventListener('resize', handleResize);

    }, []);

    const buildFactory = (property: DataObjectBase, isComplexProperty: boolean) => {

        const isReadonly = playerIsLocked ? true : !IsPropertyEditable(property, projectId, gameEnvironmentId, authUser);

        const row =
            <DataObjectComponentFactory
                route={[...route, dataObject]}
                key={property.id}
                dataObject={property}
                readonly={isReadonly}
                playerIsLocked={playerIsLocked}
                displayLabel={true} />;

        if (property) {
            return isComplexProperty ? row : <Col
                key={property.id}
                className={(customRowWidth !== undefined && customRowWidth > 700) ? styles.customCol50 : styles.customCol}>
                <div className={styles.dataRow} key={route.map(o => o.id).join('-') + property.id}>{row}</div>
            </Col>;
        }
    };

    const simplePropertiesCard = (
        <DataObjectCard>
            <Card.Body>
                <Row id="customRow" className={`${styles.customRow}`}>
                    {simpleProperties.map(property => buildFactory(property, false))}
                </Row>
            </Card.Body>
        </DataObjectCard>
    );


    return (
        complexProperties.length === 0
            ? simplePropertiesCard
            : <DataObjectCard>
                <Accordion
                    defaultActiveKey={simpleProperties.length === 0 && complexProperties.length > 0 ? dataObject.id + complexProperties[0].id : dataObject.id}
                    className={styles.m3Accordion} key={dataObject.id}>
                    {simpleProperties.length > 0 &&
                        <Accordion.Item eventKey={dataObject.id}>
                            <Accordion.Header>{dataObject.label}</Accordion.Header>
                            <Accordion.Body>
                                {simplePropertiesCard}
                            </Accordion.Body>
                        </Accordion.Item>
                    }
                    {complexProperties
                        .filter(property => property.type !== DataObjectType.postable || IsPropertyEditable(property, projectId, gameEnvironmentId, authUser))
                        .map(property => {
                            if (property !== undefined)
                                return <Accordion.Item key={dataObject.id + property.id}
                                                       eventKey={dataObject.id + property.id}>
                                    <Accordion.Header>{property.label}</Accordion.Header>
                                    <Accordion.Body>
                                        {buildFactory(property, true)}
                                    </Accordion.Body>
                                </Accordion.Item>;

                            return null;
                        })
                    }
                </Accordion>
            </DataObjectCard>
    );
};
